<!--マイナンバー申請確認 -->
<template>
  <div class="i0005">
    <div class="i0005-title">
      <!-- マイナンバー取得の利用目的 -->
      <p>{{$t('MODULE.I0005_LBL_TITLE')}}</p>
    </div>
    <div class="i0005-main">
      <ul>
        <li>
          <!-- 給与所得・退職所得の源泉徴収票作成事務 -->
          {{$t('MODULE.I0005_LBL_TEXT1')}}
        </li>
        <li>
          <!-- 給与所得者の扶養控除等(異動)申告書作成事務 -->
          {{$t('MODULE.I0005_LBL_TEXT2')}}
        </li>
        <li>
          <!-- 給与所得者の保険料控除申告書作成事務 -->
          {{$t('MODULE.I0005_LBL_TEXT3')}}
        </li>
        <li>
          <!-- 給与所得者の配偶者特別控除申告書作成事務 -->
          {{$t('MODULE.I0005_LBL_TEXT4')}}
        </li>
        <li>
          <!-- 地方税に関する事務 -->
          {{$t('MODULE.I0005_LBL_TEXT5')}}
        </li>
        <li>
          <!-- 労働保険(労災保険・雇用保険)に関する事務 -->
          {{$t('MODULE.I0005_LBL_TEXT6')}}
        </li>
        <li>
          <!-- 健康保険・厚生年金保険法に関する事務 -->
          {{$t('MODULE.I0005_LBL_TEXT7')}}
        </li>
        <li>
          <!-- 国民健康保険法の第3号被保険者制度に関する事務 -->
          {{$t('MODULE.I0005_LBL_TEXT8')}}
        </li>
      </ul>
    </div>
    <!--義務説明-->
    <div class="table-label" style="padding-left:10px;color:red;padding-top:12px;line-height:23px">
      <span style="letter-spacing:1px" v-html="$t('MODULE.I0005_LBL_TEXT')"></span>
    </div>
    <!-- 上記内容に同意します。 -->
    <el-checkbox style="margin-top:10px;" :value="checked" @change="changeConsent()" :disabled="this.disabledChkConsent">
      <div class="table-label">{{$t('MODULE.I0005_LBL_ABOVE_AGREE')}}</div>
    </el-checkbox>
    <div align="center">
      <!-- 入力画面ボタン -->
      <el-button class="i0005-css-btn css-button" style="margin-top: 8px;width:70px;padding-left:8px;font-size:13px;" type="primary" :disabled="this.disabledBtnConsent" @click="btn_input()">{{$t('MODULE.I0005_BTN_TEXT1')}}</el-button>
    </div>
    <!-- マイナンバー提出を拒否します。-->
    <el-checkbox style="margin-top:30px;" :value="checkedNo" @change="changeNO()" :disabled="this.disabledChkNo">
      <div class="table-label">{{$t('MODULE.I0005_LBL_CONSENT')}}</div>
    </el-checkbox>
    <div align="center">
      <!-- 確定ボタン-->
      <el-button class="i0005-css-btn css-button" style="margin-top: 8px;width:70px;padding-left:18px;font-size:13px;" type="primary" :disabled="this.disabledBtnNo" @click="btn_no_confirm()">{{$t('MODULE.I0005_BTN_TEXT2')}}</el-button>
    </div>
  </div>
</template>
<script>
import * as amsApi from "../api/i_0005"
import css from "@/statics/css"
let url = require("@/../config/sysConfig")
export default {
  mixins: [css],
  data() {
    return {
      checked: false,
      checkedNo: false,
      disabledChkConsent: false,
      disabledChkNo: false,
      disabledBtnConsent: false,
      disabledBtnNo: false,
      userCd: '',
    }
  },
  created() {
    this.disabledChkConsent = false;
    this.disabledChkNo = false;
    this.disabledBtnConsent = true;
    this.disabledBtnNo = true;
    this.userCd = JSON.parse(localStorage.getItem('userInfo')).userCd;
  },
  watch: {
    checked: function (val) {
      if (val == true) {
        this.disabledBtnConsent = false;
      } else if (val == false) {
        this.disabledBtnConsent = true;

      }
    },

    checkedNo: function (val) {
      if (val == true) {
        this.disabledBtnNo = false;
      } else if (val == false) {
        this.disabledBtnNo = true;
      }
    },
  },
  methods: {
    //入力画面ボタン
    btn_input() {
      //API「スタッフ申請確認ログ保存」を呼び出す。
      var params = {
        stfConfirmType: "1",//マイナンバー
        stfConfirmResult: "1",//同意
        stfConfirmUserCd: JSON.parse(localStorage.getItem('userInfo')).userCd,
      };
      amsApi.i_0005_update(params, this.userCd).then(res => {
        if (res.code === 202) {
          //マイナンバー申請画面へ遷移
          this.$router.push({ path: url.routerUrl_I0006 });
        } else if (res.code === 311) {
          this.$message.error({ message: this.$t('COMMON.CURD_ERROR'), showClose: true });//保存失敗
        }
      });
    },
    //確定ボタン
    btn_no_confirm() {
      //API「スタッフ申請確認ログ保存」を呼び出す。
      var params = {
        stfConfirmType: "1",//マイナンバー
        stfConfirmResult: "2",//拒否
        stfConfirmUserCd: JSON.parse(localStorage.getItem('userInfo')).userCd,
      };
      amsApi.i_0005_update(params, this.userCd).then(res => {
        if (res.code === 202) {
          this.$message.success({ message: this.$t('COMMON.UPDATED'), showClose: true }) //更新成功
          //同意チェック・入力画面ボタン・拒否チェック・確定ボタンを非活性にする。
          this.disabledChkConsent = true;
          this.disabledChkNo = true;
          this.disabledBtnConsent = true;
          this.disabledBtnNo = true;
        } else if (res.code === 311) {
          this.$message.error({ message: this.$t('COMMON.CURD_ERROR'), showClose: true });//保存失敗
        }
      });
    },
    //上記内容に同意します。チェック按下
    changeConsent() {
      this.checked = !this.checked;
      //同意・拒否が同時チェックの場合
      if (this.checked && this.checkedNo) {
        //同意・拒否は同時にチェックできません。
        this.$message.warning({ message: this.$t('MODULE.I0005_MSG_MYNO_AGREE_REFUSE'), showClose: true });
        this.checked = false;
      }
    },
    //マイナンバー提出を拒否します。チェック按下
    changeNO() {
      this.checkedNo = !this.checkedNo;
      //同意・拒否が同時チェックの場合
      if (this.checkedNo && this.checked) {
        //同意・拒否は同時にチェックできません。
        this.$message.warning({ message: this.$t('MODULE.I0005_MSG_MYNO_AGREE_REFUSE'), showClose: true });
        this.checkedNo = false;
      }
    }
  }
}
</script>
<style>
.i0005-title {
  color: rgb(71, 71, 71);
  text-align: center;
  margin-top: 10px;
  height: 40px;
  border-radius: 3px;
  border: 1px solid rgb(165, 165, 165);
  background-image: linear-gradient(#f0f0f0, #e0e0e0);
  font-size: 15px;
}
.i0005-main {
  color: rgb(71, 71, 71);
  margin-top: 10px;
  border-radius: 3px;
  border: 1px solid rgb(165, 165, 165);
  font-size: 15px;
}
.i0005 ul {
  padding-inline-start: 20px;
}
.i0005 p {
  margin-top: 10px;
}
.i0005-css-btn {
  margin-top: 15px;
  width: 100px;
  height: 40px;
  padding-top: 10px;
  background-image: linear-gradient(0deg, #3cc6fa, #23b2e8);
}
/*按钮经过样式*/
.i0005-css-btn:hover {
  background-image: linear-gradient(0deg, #0f91c2, #41bae6);
}

/*按钮激活和焦点样式*/
.i0005-css-btn:active,
.i0005-css-btn:focus {
  background-image: linear-gradient(0deg, #29a8d8, #29a8d8);
}
</style>


// WEBPACK FOOTER //
// src/module/page/i_0005.vue